<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="
                                            tables.feedback_logs.allFields
                                        "
                                        :activeFields.sync="
                                            tables.feedback_logs.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.feedback_logs.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.feedback_logs.fields,
                                        fields:['label']
                                    })"
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20, 50, 100, 500, 1000, 5000, 10000],
                                    }"
                                    :columnFilterValue.sync="tables.feedback_logs.columnFilterValue"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.feedback_logs.rows"
                                    v-bind="tables.feedback_logs"
                                >
                                    <template #message="{ item }" >
                                        
                                        <td>
                                            <div class="pre">
                                                <div class="pre__container">
                                                    <div class="span__pre">
                                                        <code>
                                                            {{(item.message)}}
                                                        </code>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </template>
                                    <template #request_report="{ item }" >
                                        <td>
                                            <div class="request-report">
                                                {{item.request_report}}
                                            </div>
                                            
                                        </td>
                                    </template>
                                    
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.feedback_logs.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.feedback_logs.page"
                                    :pages="tables.feedback_logs.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonBack from "£lement/ButtonBack";
import TableSettings from "£lement/TableSettings";

/** Mixins */
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table.js'

/** Others */
import { mapGetters } from "vuex";
import { cilPlus, cilSettings, cilPencil, cilTrash, cilArrowThickFromRight } from '@coreui/icons';

export default {
    name:"IntegrationsFeedbackLogsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, tableMixin ],
    components:{
        FilterDate,
        ButtonBack,
        TableSettings
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight
    },
    data(){
        return{
            tables:{
                feedback_logs:{
                    fields: [
                        {
                            key: "id",
                            label:"#",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                        },
                        {
                            key: "lead_id",
                            label:"lead_id",
                            sorter: false,
                            filter: true,
                            _style: "width:15%",
                        },
                        {
                            key: "request_report",
                            label:"request_report",
                            sorter: false,
                            filter: true,
                            _style: "width:20%",
                        },
                        {
                            key: "message",
                            label:"message",
                            sorter: false,
                            filter: true,
                            _style: "width:20%",
                        },
                        {
                            key: "created_at",
                            label:"created_at",
                            sorter: false,
                            filter: false,
                            _style: "width:20%",
                        }
                    ],
                    allFields: [],
                    items:[],
                    order:"desc",
                    rows:10,
                    page:1,
                    total_pages:0,
                    loading:true,
                    pagination:true,
                    sorter:true,
                    responsive:true,
                    columnFilter:{ 
                        external: true, 
                        lazy: true 
                    },
                    columnFilterValue:{},
                    itemsPerPageSelect:true,
                }
            }
        }
    },
    computed:{
        ...mapGetters({
            from:"filter/from",
            to:"filter/to"
        }), 
        title_page:function(){
            return this.$t("answers");
        },
        trigger_uuid:function(){
            return this.$route.params.trigger_uuid;
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.feedback_logs.rows = newValue;
            this.updatePagination(this.tables.feedback_logs.page);
        },
        updatePagination(newValue){
            this.tables.feedback_logs.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"feedback_logs", 
                url:'/trigger.api/feedback/logs/'+ this.trigger_uuid, 
            });
            this.updatePageLoading(false);
        }
    },
    mounted(){
        this.updateData();
    }

}
</script>

<style scoped lang="scss">
    /* .request-report{
        overflow: hidden;
        width: 30%;
    }
    .message{
        width: 30%;
        overflow: hidden;
    } */
    .message__container{
        overflow: hidden;
    }

    .pre{
        & .pre__container{
            max-width: 30rem;
            overflow: auto;
            & .span__pre {
                display: block;
                unicode-bidi: embed;
                font-family: monospace;
                /* white-space: pre; */
                white-space: pre-wrap;
            }
        }
        
    }
    
    
</style>